module.exports = __webpack_public_path__ + "static/img/ecotemp3-icon.7c5f156.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/refs/eco/ecotemp3-icon.jpg
// module id = tr9j
// module chunks = 0